module.exports = __webpack_public_path__ + "media/images/img-shepherd-d1e47694f0f331cbac3a4a3bf19d9c02.svg";